import dataSource from "@/data/DataSource";
import dataTableUtils from "./DataTableUtils";
import alertService from "@/components/core/alert/AlertService";

export default {

  getIdentityTemplate() {
    return new Promise(resolve => {
      dataSource.getClientIdentifierTemplate(0)
        .then(res => {
          if (res.errorOccurred) {
            alertService.alert({ message: res.data })
          } else {
            resolve(res.data)
          }
        })
    })
  },

  getClientIdentifier(clientId, documentType) {
    return new Promise(resolve => {
      this.getIdentityTemplate()
        .then(res => {
          const documentTypeId = dataTableUtils.getDocumentTypeId(res.allowedDocumentTypes,
            documentType.documentType
          );
            dataSource.getClientIdentifiers(clientId).then(res => {
            if (res.errorOccurred) {
              alertService.alert({ message: res.data })
            } else {
              let identifier = res.data.filter(identity =>
                identity.documentType.id == documentTypeId
              )[0];
              resolve(identifier)
            }
          })
        })
    })
  }
}